import React from 'react';

const BorderDashedIcon: React.FC = () => (
  <svg width="332" height="1" viewBox="0 0 332 1" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="4.37114e-08" y1="0.500122" x2="332" y2="0.500151" stroke="#D0D5DD" strokeDasharray="6 6" />
  </svg>
);

export default BorderDashedIcon;
